import { createI18n } from 'vue-i18n';
import { getI18nMessages } from './language/language.model';

function detectDefaultLocale() {
	const savedLocale = localStorage.getItem('locale');
	if (savedLocale) return savedLocale;
	const browserLang = navigator.language || navigator.userLanguage;
	let langCode = browserLang.split('-')[0];
	if (langCode === 'ja') langCode = 'jp';
	if (langCode === 'ko') langCode = 'kr';
	if (browserLang === 'zh-TW') langCode = 'tw';
	if (browserLang === 'zh-CN') langCode = 'sc';

	const validLangs = ['en', 'es', 'tw', 'sc', 'jp', 'kr', 'vi'];
	if (!langCode || !validLangs.includes(langCode)) {
		langCode = 'en';
	}

	localStorage.setItem('locale', langCode || 'en');
	return langCode || 'en';
}

const i18n = createI18n({
	legacy: false,
	locale: detectDefaultLocale(),
	fallbackLocale: 'en',

	fallbackWarn: false,
	missingWarn: false,

	messages: getI18nMessages(),
});

export default i18n;
